// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-manager-section {
  padding: 0.313rem 0.938rem 1rem 0rem;
}
.file-upload-manager-section .file-upload-manager-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.625rem;
  padding-bottom: 0.625rem;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  border-radius: 0.625rem;
  border: 0.063rem solid var(--stroke, #acacac);
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.625rem;
  padding: 1.5rem;
  justify-content: center;
  min-height: 10rem;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-upload-container .input-file-upload {
  display: none;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-upload-container .upload-icon-cta {
  width: 1.34rem;
  height: 1.34rem;
  padding: 0;
  color: #003da5;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-upload-container .upload-icon-cta img {
  width: 1.34rem;
  height: 1.34rem;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-upload-container .upload-text p {
  line-height: normal;
  margin: 0;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-upload-container .upload-text p .upload-text-cta {
  padding: 0;
  color: #003da5;
  text-decoration-line: underline;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-dragdrop-box {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  border: 2px dashed #003da5;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 61, 165, 0.1);
  pointer-events: auto;
}
.file-upload-manager-section .file-upload-manager-container .file-upload-section .file-dragdrop-box:hover {
  border-color: #ff8000;
  background-color: rgba(255, 128, 0, 0.1);
}
.file-upload-manager-section .error-message-wrapper {
  color: #ff0000;
  display: flex;
  gap: 1rem;
  align-items: center;
}
.file-upload-manager-section .error-message-wrapper img {
  width: 24px;
  height: 24px;
}
.file-upload-manager-section .error-message-wrapper .error-message {
  font-weight: 500;
}

.version-history-dialog {
  width: 70vw;
  max-height: 100vh;
}
.version-history-dialog .flex-display {
  display: flex;
  justify-content: center;
}

.p-dialog-content {
  max-width: 100%;
}

.supplier-file-list-container .file-list-header {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/common/FileUploadManager/index.scss"],"names":[],"mappings":"AAAA;EAGE,oCAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,wBAAA;AADJ;AAGI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;AADN;AAGM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AADR;AAGQ;EACE,aAAA;AADV;AAIQ;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAvCQ;AAqClB;AAIU;EACE,cAAA;EACA,eAAA;AAFZ;AAOU;EACE,mBAAA;EACA,SAAA;AALZ;AAOY;EACE,UAAA;EACA,cAtDI;EAuDJ,+BAAA;AALd;AAWM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,oBAAA;AATR;AAUQ;EACE,qBAAA;EACA,wCAAA;AARV;AAcE;EACE,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAZJ;AAcI;EACE,WAAA;EACA,YAAA;AAZN;AAeI;EACE,gBAAA;AAbN;;AAkBA;EACE,WAAA;EACA,iBAAA;AAfF;AAkBE;EACE,aAAA;EACA,uBAAA;AAhBJ;;AAoBA;EACE,eAAA;AAjBF;;AAqBE;EACE,aAAA;AAlBJ","sourcesContent":[".file-upload-manager-section {\n  $primary-color: #003da5;\n\n  padding: 0.313rem 0.938rem 1rem 0rem;\n\n  .file-upload-manager-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.625rem;\n    padding-bottom: 0.625rem;\n\n    .file-upload-section {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 0.625rem;\n      align-self: stretch;\n      border-radius: 0.625rem;\n      border: 0.063rem solid var(--stroke, #acacac);\n\n      .file-upload-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.625rem;\n        padding: 1.5rem;\n        justify-content: center;\n        min-height: 10rem;\n\n        .input-file-upload {\n          display: none;\n        }\n\n        .upload-icon-cta {\n          width: 1.34rem;\n          height: 1.34rem;\n          padding: 0;\n          color: $primary-color;\n\n          img {\n            width: 1.34rem;\n            height: 1.34rem;\n          }\n        }\n\n        .upload-text {\n          p {\n            line-height: normal;\n            margin: 0;\n\n            .upload-text-cta {\n              padding: 0;\n              color: $primary-color;\n              text-decoration-line: underline;\n            }\n          }\n        }\n      }\n\n      .file-dragdrop-box {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        border-radius: 1rem;\n        border: 2px dashed #003da5;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        opacity: 0.5;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: rgba(0, 61, 165, 0.1);\n        pointer-events: auto; // Allow interactions\n        &:hover {\n          border-color: #ff8000; // Highlight border\n          background-color: rgba(255, 128, 0, 0.1); // Highlight background\n        }\n      }\n    }\n  }\n\n  .error-message-wrapper {\n    color: #ff0000;\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n\n    img {\n      width: 24px;\n      height: 24px;\n    }\n\n    .error-message {\n      font-weight: 500;\n    }\n  }\n}\n\n.version-history-dialog {\n  width: 70vw;\n  max-height: 100vh;\n  // height: 50vh;\n\n  .flex-display {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.p-dialog-content {\n  max-width: 100%;\n}\n\n.supplier-file-list-container {\n  .file-list-header {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
